/**
 * 交班概览
 */
import React, { useContext, useEffect, useMemo } from 'react';
import { message } from 'antd';
import intl from 'react-intl-universal';

import { parseFen2Yuan } from '@/utils/number';
import { DrawerContext, HandoverInfo } from '@/pages/handover/helper';
import { updateHandoverShiftText } from '@/api/handover';
import { getCdnHost } from '@/config/apiHosts';

import IndicatorList from '../IndicatorList';
import RichText from '../RichText';
import styles from './index.module.scss';

interface IProps {
  handoverInfo: HandoverInfo;
  updateShiftText: (val: string) => void;
}

const Index: React.FC<IProps> = (props) => {
  const { getHandoverInfo, handoverId } = useContext(DrawerContext);
  const { handoverInfo, updateShiftText } = props;

  const indicatorList = [
    {
      name: intl.get('handover_indicator_last_petty'),
      label: intl.get('handover_indicator_last_petty'),
      icon: `${getCdnHost()}/image/common/20230403/165810147-rest_reverse.png`,
      content: parseFen2Yuan(handoverInfo.lastPettyCash),
    },
    {
      name: intl.get('handover_indicator_next_petty'),
      label: intl.get('handover_indicator_next_petty'),
      icon: `${getCdnHost()}/image/common/20230403/165810154-reverse.png`,
      content: parseFen2Yuan(handoverInfo.nextPettyCash),
    },
    {
      name: intl.get('handover_indicator_hand_in_petty'),
      label: intl.get('handover_indicator_hand_in_petty'),
      icon: `${getCdnHost()}/image/common/20230403/165810088-cash.png`,
      iconHeight: 42,
      content: parseFen2Yuan(handoverInfo.handInPettyCash),
    },
  ];

  // 保存交班须知
  const autoSaveText = useMemo(() => {
    let timer;
    return (shiftText) => {
      updateShiftText(shiftText);
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (handoverId) {
          if (shiftText && shiftText.length > 100000) {
            message.error(intl.get('handover_notice_error_over_limit'));
            return;
          }
          updateHandoverShiftText({ id: handoverId, shiftText });
        }
      }, 1000);
    };
  }, [handoverId]);

  const handleTextChange = (text) => {
    autoSaveText(text);
  };

  useEffect(() => {
    updateShiftText('');
    getHandoverInfo();
  }, []);

  return (
    <div className={styles.overviewWrapper}>
      <IndicatorList items={indicatorList} />
      <div className={styles.handoverNotice}>
        <div className="groupLabel">{intl.get('handover_notice_block_title')}</div>
        <p className={styles.handoverHint}>{intl.get('handover_notice_block_hint')}</p>
        <RichText
          key={handoverInfo.shiftText}
          defaultValue={handoverInfo.shiftText}
          onChange={handleTextChange}
        />
      </div>
    </div>
  );
};

export default Index;
